/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mandatory_It_SkillsInputs */

const de_mandatory_it_skills = /** @type {(inputs: Mandatory_It_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IT-Kenntnisse (verpflichtend)`)
};

/** @type {(inputs: Mandatory_It_SkillsInputs) => LocalizedString} */
const en_mandatory_it_skills = () => /** @type {LocalizedString} */ ('mandatory_it_skills')

/**

* @param {Mandatory_It_SkillsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const mandatory_it_skills = /** @type {((inputs?: Mandatory_It_SkillsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mandatory_It_SkillsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_mandatory_it_skills(inputs)
	return en_mandatory_it_skills(inputs)
});